import React, { Component } from 'react'
import withStyles from '../../../withStylesAdapter';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';

class Faq extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          FAQ
        </Typography>
        <Divider className="divider-white" />
        
        <Paper className={classes.root} elevation={1}>
        
        </Paper>
      </React.Fragment> 
    )
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 20,
    overflowX: 'auto',
    padding: 24,
  },
  contentContainer: {
    marginBottom: theme.spacing(4),
  },
})

export default withStyles(styles)(Faq)